export default {
  meta: {
    title: $localize`:@@meta.provably_fair.description.title:Подробное описание → CSFAIL`,
    description: $localize`:@@meta.provably_fair.description.description:Описание работы системы честной игры. С помощью этих знаний Вы можете проверить любой режим CSFAIL на честность при выборе победителя!`
  }
};